export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\"/><path class=\"path\" d=\"M21.333 21.333H2.667V2.667H12V0H2.667C1.187 0 0 1.2 0 2.667v18.666A2.666 2.666 0 002.667 24h18.666C22.8 24 24 22.8 24 21.333V12h-2.667v9.333zM14.667 0v2.667h4.786L6.347 15.773l1.88 1.88L21.333 4.547v4.786H24V0h-9.333z\" fill=\"#000\" fill-rule=\"nonzero\"/></g>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};